export function TutorListingPage() {
  return <div className="text-gray-500">Tutor listing page - coming soon.</div>
}
